<template>
	<div>
		<div class="title">
			<div>
				<h1>Time-sheets client<i class="fa fa-refresh fa-spin" aria-hidden="true"></i></h1>
			</div>
			<v-dialog/>
			<modal 	name="modal-confirm"
					:classes="['v--modal', 'modal-confirm']"
					:pivot-y="0.2"
					:width="400"
					:height="125">
				<div class="confirm-modal-content">
					<div class="modal-title">
						<h6><b>Voulez-vous valider la time-sheet ?</b></h6>
					</div>
					<div class="modal-button">
							<button @click="$modal.hide('modal-confirm')">Annuler</button>
							<button @click="confirmValidation">Confirmer</button>
					</div>
				</div>
			</modal>
			<div class="text-right">
				<div class="form-group">
					<select v-model="idclient" v-on:change="getTimeSheet">
						<option value="" selected disabled>Client</option>
						<option v-bind:value="client.id" v-for="client in allClients">{{ client.user.name }}</option>
					</select>

					<label for="surname">Archives</label>
					<select v-model="month" @change="getTimeSheet">
						<option value="null" selected disabled>Mois</option>
						<option value="0">Janvier</option>
						<option value="1">Février</option>
						<option value="2">Mars</option>
						<option value="3">Avril</option>
						<option value="4">Mai</option>
						<option value="5">Juin</option>
						<option value="6">Juillet</option>
						<option value="7">Août</option>
						<option value="8">Septembre</option>
						<option value="9">Octobre</option>
						<option value="10">Novembre</option>
						<option value="11">Décembre</option>
					</select>
					<select v-model="year" v-on:change="getTimeSheet">
						<option v-for="(value, index) in years" v-bind:value="value">{{ value }}</option>
					</select>
					<button
						class="green-btn"
						@click="pdf"
						v-bind:class="{disabled_btn: !timesheet || timesheet.length === 0}"
						v-bind:disabled="!timesheet || timesheet.length === 0">
						<i class="fa fa-file-pdf-o" aria-hidden="true"></i> Téléchargez en pdf
					</button>
					<button
						class="green-btn"
						@click="excel"
						v-bind:class="{disabled_btn: !timesheet || timesheet.length === 0}"
						v-bind:disabled="!timesheet || timesheet.length === 0">
						<i class="fa fa-file-excel-o" aria-hidden="true"></i> Téléchargez en xls
					</button>
				</div>
			</div>
		</div>
		<div class="row main-wrap">
			<div class="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
				<table class="table table-striped table-bordered">
					<thead>
						<tr>
							<th colspan="2" class="empty"></th>
							<th v-bind:colspan="utilisateurs.length" class="text-center">Charge de travail</th>
						</tr>
						<tr>
							<th width="50%">Actions</th>
							<th>Date</th>
							<template v-if="utilisateurs.length > 0">
								<th class="text-center" v-for="utilisateur in utilisateurs">{{ utilisateur.user.name }}{{ utilisateur.user.surename }}</th>
							</template>
							<template v-else>
								<th></th>
							</template>
						</tr>
					</thead>
					<tbody>
						<tr v-for="time in timesheet">
							<td>{{ time.action_categorie.name }} : {{ time.action_type.name }} - {{ time.action_commentaire }}</td>
							<td>{{ time.dateclean }}</td>
							<td v-for="utilisateur in utilisateurs" class="text-center">
								<template v-for="time_user in time.utilisateur" v-if="utilisateur.iduser == time_user.iduser">
									{{ time_user.temps_timesheet }}
								</template>
							</td>
						</tr>
					</tbody>
				</table>
				<table class="table table-striped table-bordered">
					<thead>
						<tr>
							<th width="50%">
								TOTAL DU NOMBRE DE JOURS TRAVAILLÉS
							</th>
							<th colspan="3" class="text-center">
								{{ total.jours }}
							</th>
						</tr>
					</thead>
				</table>
				<table class="table table-striped table-bordered" v-if="hideClientSolde != 1">
					<thead>
						<tr>
							<th width="50%">
								SOLDE DU MOIS PRÉCÉDENT
							</th>
							<th colspan="3" class="text-center">
								{{ total.solde }}
							</th>
						</tr>
					</thead>
				</table>
				<table class="table table-striped table-bordered" v-if="hideClientSolde != 1">
					<thead>
						<tr>
							<th width="50%">
								NOUVEAU SOLDE DU COMPTE TEMPS
							</th>
							<th colspan="3" class="text-center">
								{{ total.nouveausolde }}
							</th>
						</tr>
					</thead>
				</table>
				<div class="submit-btn pull-right" :hide="hide == 1 ? true : false" :class="{hide : hide}">
					<button type="submit" class="green-btn" v-if="disabled == false" v-on:click="show" :disabled="disabled == 1 ? true : false" :class="{disabled : disabled}">Valider</button>
					<button type="submit" class="disabled_btn green-btn" v-if="disabled == true" :disabled="disabled == 1 ? true : false" :class="{disabled : disabled}">Time-sheet validé</button>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from '../js/app.js';
import timesheets from '../js/timesheets.js';

export default {
    data() {
        return {
			hideClientSolde: 0,
			disabled: 0,
			hide: 1,
			allClients: [],
            idclient: '',
			timesheet: null,
			validatedtimesheet: '',
            year: new Date().getFullYear(),
            month: new Date().getMonth(),
            oldest:null,
            years:[new Date().getFullYear()],
			utilisateurs:[],
            total:{
            	jours: 'XX',
            	solde: 'XX',
				nouveausolde: 'XX',
				nbJoursVendus: 'XX',
            }
        }
    },
    beforeCreate: function () {
        this.$nextTick(function () {
        	this.clients();
        })
	},
	mounted: function()  {
		if (this.$route.params.idclient && this.$route.params.year && this.$route.params.month) {
			this.idclient = this.$route.params.idclient;
			this.year = this.$route.params.year;
			this.month = this.$route.params.month;
			Vue.http.post(
				'/api/timesheet/timesheet',
				{
					idclient: this.idclient,
					year: this.year,
					month: this.month,
				}).then(response => {
					if (response.data.error) {
						console.log(response.data.error)
					}
					else {
						console.log(response)
						this.timesheet = response.data.data;
						this.utilisateurs = response.data.utilisateurs;
						this.oldest = response.data.oldest;
						this.total.jours = response.data.total_jours.toFixed(2);
						this.total.nbJoursVendus = response.data.jours_vendus;
						if (response.data.solde_precedent) {
							this.total.solde = response.data.solde_precedent.value.toFixed(2);
						} else {
							this.total.solde = 0;
						}
						this.total.nouveausolde = (this.total.jours + this.total.solde - this.total.nbJoursVendus).toFixed(2);
						if (this.years.length <= 1 && this.years[0] == new Date().getFullYear()) {
							this.year = new Date().getFullYear();
							this.years = [];
							for (var i = this.oldest; i <= this.year; i++) {
								this.years.push(i)
							}
						}

						if (this.timesheet.length == 0 || this.timesheet == undefined) {
							this.hide = 1;
							this.disabled
						} else {
							this.hide = 0;
						}
					}
				})
		}
	},
    methods: {
	    clients() {
			Vue.http.get(
				'/api/client?section=list',
			).then(response => {
				this.allClients = _.orderBy(response.data.data, 'name')
			})
		},
	    getTimeSheet(){
			Vue.http.post(
				'/api/timesheet/getValidateData',
					{
						idclient: this.idclient,
						year: this.year,
						month: this.month,
					}).then(response => {
						console.log(response.data.data);
						this.validatedtimesheet = response.data.data;
						if(response.data.data.length == 0 || response.data.data == undefined){
							this.disabled = 0;
						}else{
							this.disabled = 1;
						}
					})
	    	if( this.idclient ) {
		    	Vue.http.post(
		    		'/api/timesheet/timesheet',
			    {
			        idclient: this.idclient,
			        year: this.year,
			        month: this.month,
			    }).then( response => {
					if (response.data.error) {
						console.log('error')
					}
					else {
						this.timesheet = response.data.data;
						this.utilisateurs = response.data.utilisateurs;
						this.oldest = response.data.oldest;
						this.total.jours = response.data.total_jours;
						this.total.nbJoursVendus = response.data.jours_vendus;
						if( response.data.solde_precedent ) {
							this.total.solde = response.data.solde_precedent.value;
						} else {
							this.total.solde = 0;
						}
						this.total.nouveausolde = (this.total.jours + this.total.solde - this.total.nbJoursVendus).toFixed(2);
						this.total.solde = this.total.solde.toFixed(2);

						if( this.years.length <= 1 && this.years[0] == new Date().getFullYear()) {
							this.year = new Date().getFullYear();
							this.years = [];
							for( var i = this.oldest; i <= this.year; i++) {
								this.years.push(i)
							}
						}

						if(this.timesheet.length == 0 || this.timesheet == undefined) {
							this.hide = 1;
							this.disabled
						}else{
							this.hide = 0;
						}

						var clientToHide = [2,46,5,7,9,10,11,45,12,13,14,15,16,17,18,20,21,22,23,25,27,28,29,30,32,38,39,40];
						if(clientToHide.indexOf(this.idclient) >= 0){
							this.hideClientSolde = 1;
						}else{
							this.hideClientSolde = 0;
						}
					}
				})
			}
		},

		excel(){
			if( this.idclient ) {
		    	Vue.http.post(
		    		'/api/timesheet/exceltimesheet',
			    {
			        idclient: this.idclient,
			        year: this.year,
			        month: this.month,
			    }).then(response => {
					console.log(response);
					// footable.fooTable();
					window.open(response.body.file)
				})
			}
		},
		pdf() {
			if( this.idclient ) {
		    	Vue.http.post(
		    		'/api/timesheet/pdf',
			    {
			        idclient: this.idclient,
			        year: this.year,
			        month: this.month,
			    }).then(response => {
					console.log(response.data);
					// footable.fooTable();
					window.open(window.location.protocol + '//' + window.location.host + response.data)
				})
			}
		},
		validate() {
			timesheets.validate(this, this.idclient, this.month, this.year);
		},
		show() {
			this.$modal.show('modal-confirm')
		},
		confirmValidation(){
			this.$modal.hide('modal-confirm');
			this.disabled = 1;
			this.validate(event);
			this.$modal.show('dialog', {
				text: 'Le time-sheet a été validé',
				class: 'modal-success',
				buttons: [
					{ title: 'Fermer' }
				]
			})
		},
		getTimesheetDataValidate(){
			Vue.http.post(
				'/api/timesheet/getValidateData',
					{
						idclient: this.idclient,
						year: this.year,
						month: this.month,
					}).then(response => {
						this.validatedtimesheet = response.data.data[0];
						if(response.data.data.length == 0 || response.data.data == undefined){
							this.disabled = 0;
						}else{
							this.disabled = 1;
						}
					})
		}
    }
}
</script>

<style lang="scss">
   @import '../sass/app.scss';
</style>



// WEBPACK FOOTER //
// Timesheet.vue?77190405